import { Box } from "@mui/material";
import CommonDrawer from "../../drawer/CommonDrawer";
import CommonPayViaModalContent from "../../CommonPayViaModalContent";

function WithdrawPayViaModal({
  amount,
  setAmount,
  currency,
  setCurrency,
  isOpen,
  setIsOpen,
  paymentMethods,
  setButtonLoader,
  setBalance,
  balanceData,
  data,
  minTransactionAmt,
  setMinTransactionAmt,
  maxTransactionAmt,
  setMaxTransactionAmt,
}) {
  const handleDrawerClose = () => {
    setIsOpen(false);
  };

  const commonContent = {
    setIsPayViaOpen: setIsOpen,
    balanceData,
    withdrawData: data,
    setBalance,
    currency,
    setCurrency,
    setButtonLoader,
    amount,
    setAmount,
    paymentMethods,
    isShowHeading: true,
    minTransactionAmt,
    setMinTransactionAmt,
    maxTransactionAmt,
    setMaxTransactionAmt,
  };

  return (
    <CommonDrawer
      anchor="bottom"
      open={isOpen}
      onClose={handleDrawerClose}
      className="withdraw-payVia-drawer"
    >
      <Box className="withdraw-pay-via-container">
        <CommonPayViaModalContent {...commonContent} />
      </Box>
    </CommonDrawer>
  );
}

export default WithdrawPayViaModal;
